module.exports = __webpack_public_path__ + "static/media/selectarrow.57608552.svg";